import React from 'react';
import { Tabs, Tab } from 'material-ui/Tabs';
// From https://github.com/oliviertassinari/react-swipeable-views
import SwipeableViews from 'react-swipeable-views';

import BusTable from './busTable'
import TyphoonBusTable from './typhoonBusTable'
import PriceTable from './priceTable'

const styles = {
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  slide: {
    padding: 10,
  },
};

const Red = (e) => {
  return (
    <font style={{ color: '#FF0000' }}>{e.text}</font>
  )
}

export default class TabsExampleSwipeable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      slideIndex: 0,
    };
  }

  handleChange = (value) => {
    this.setState({
      slideIndex: value,
    });
  };

  render() {
    return (
      <div>
        <Tabs
          onChange={this.handleChange}
          value={this.state.slideIndex}
        >
          <Tab label="如何來本院" value={0} buttonStyle={{ color: 'white' }} />
          <Tab label="免費接駁車" value={1} buttonStyle={{ color: 'white' }} />
          <Tab label="停車資訊" value={2} buttonStyle={{ color: 'white' }} />
        </Tabs>
        <SwipeableViews
          index={this.state.slideIndex}
          onChangeIndex={this.handleChange}
        >
          <div>
            <h2 style={styles.headline}>捷運</h2>
            本院位於捷運關渡站與忠義站之間，您可以搭乘捷運淡水線，在忠義站或關渡站下車。<br />
            如果您行動方便，可在忠義站下車，請您由捷運站二號出口出站後右轉，沿著捷運鐵路的步道，步行五分鐘，便可以看到和信治癌中心醫院的建築物。<br />
            如果您陪伴著行動不便的病人來醫院，您可以在關渡站下車，搭乘和信治癌中心醫院為您準備的免費接駁交通車，接駁車站牌遷移至關渡捷運站1號出口旁第二個路燈位置, 請您依右邊接駁車時間表搭乘至本院。<br />
            <h2 style={styles.headline}>自行開車</h2>
            本院地址為台北市北投區立德路125號。從台北市方向出發，您可由洲美快速道路或其他路線往淡水方向，經大度路後右轉立德路到達。大度路與立德路路口之明顯地標為慈濟關渡志業園區，進入立德路後約500公尺，本院位於左側。
          </div>
          <div style={styles.slide}>
            <h2 style={styles.headline}>注意事項：</h2>
            <ol style={{ paddingLeft: '20px' }}>
              <li>接駁車站牌在和信醫院正門口及關渡捷運站門口站牌處</li>
              <li>每班次限搭乘二十位乘客，以<Red text='病人' />、<Red text='家屬' />優先搭乘</li>
              <li>週六下午及醫院休診日不行駛</li>
              <li>週一 至 週六 <Red text='上午' /> 08:30-10:30 每20分鐘一班，10:30-12:30 每15分鐘一班</li>
              <li>週一 至 <Red text='週五 下午' /> 13:30-18:00 每15分鐘一班</li>
            </ol>
            <BusTable />
            <h2 style={styles.headline}>颱風天加開服務：</h2>
            為維護病人、家屬及員工於颱風日通勤安全，當颱風日台北市政府已宣佈停止上班，醫院維持正常門診狀況，且捷運淡水線仍正常運行，行駛於醫院至關渡捷運站間之接駁車，除現有班次外加開部分機動班次如下：
            <TyphoonBusTable />
          </div>
          <div style={styles.slide}>
            <h3 style={styles.headline}>汽機車停車資訊</h3>
            <ol style={{ paddingLeft: '20px' }}>
              <li>地下停車場可直通本院大樓，如果您陪伴著行動不便的病人來醫院，建議優先使用地下停車場。</li>
              <li>本院於大門周邊設有265個機車停車格，可供來賓使用。</li>
              <li>本院停車場收費標準：</li>
            </ol>
            <PriceTable />
            <ol style={{ paddingLeft: '20px' }} start="4">
              <li>本院停車空間有限，陪病家屬或住院病人若有長期停車需求，可參考鄰近醫院週邊停車場長期停車優惠：</li>
            </ol>
            <ul style={{ paddingLeft: '30px' }}>
              <li>立功停車場：計時 50元 / 小時；計次 350元 / 12小時 (步行300公尺)</li>
              <li>立德路公有汽車停車格：計時 20元 / 小時</li>
              <li>捷運忠義站：計時 20元 / 小時(步行200公尺)</li>
            </ul>
          </div>
        </SwipeableViews>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/tabs.js